import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";
import PhoneLogin from "@/components/PhoneLogin";
import { firebaseReady } from "@/lib/firebase";

// Admin / email-login routes stay reachable so staff can sign in; everything else requires OTP login first.
const EXEMPT = ["/login", "/signup", "/admin"];

export default function LoginGate() {
  const { user, ready } = useApp();
  const loc = useLocation();
  const exempt = EXEMPT.some((p) => loc.pathname === p || loc.pathname.startsWith(p + "/"));
  const show = ready && !user && !exempt && firebaseReady;

  useEffect(() => {
    if (!show) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [show]);

  if (!show) return null;
  return (
    <div data-testid="login-gate" role="dialog" aria-modal="true" aria-label="Sign in to continue"
      className="fixed inset-0 z-[300] flex items-end sm:items-center justify-center bg-[#292724]/80 backdrop-blur-sm p-0 sm:p-6">
      <div className="w-full sm:max-w-md bg-white rounded-t-3xl sm:rounded-3xl shadow-2xl overflow-hidden">
        <div className="bg-[#292724] text-white px-6 py-6">
          <div className="eyebrow text-[#d4af37] text-[10px] mb-1">Welcome to Tent N Tap</div>
          <h2 className="font-serif text-2xl sm:text-3xl font-light">Sign in to continue</h2>
          <p className="text-white/70 text-xs mt-2">Enter your mobile number — we'll send a one-time OTP. Your selections, bookings and curator chat stay linked to this number.</p>
        </div>
        <div className="p-6">
          <PhoneLogin testPrefix="gate-phone-login" />
          <div className="mt-5 flex items-center justify-between text-[11px] text-[#8a837a]">
            <span className="inline-flex items-center gap-1"><ShieldCheck className="w-3 h-3 text-[#d4af37]" /> Secured by Firebase · no password needed</span>
            <Link to="/login" data-testid="gate-email-login" className="text-[#d4af37] hover:underline">Email login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
